<template>
    <div class="modal" :class="{'modal-open': show}">
    <div class="modal-box bg-red-custom-3">
      <ExclamationTriangleIcon class="w-24 h-24 mx-auto text-red-custom-4" />
        <p class="text-red-custom-4 pt-4 text-j">
        {{ __('The invoice list includes products that are out of stock. You can use the following buttons to remove non-existent goods from the invoice or add them to your reservation list so that they will be invoiced for you in the reservation menu and we will inform you through notification (messages) if the balance is charged. Finalize your invoice and send the product to you')}}
        </p>
        <p class="text-black pb-4 pt-2">{{__('Note that the product will be invoiced for you at the current price!')}}</p>
      <div class="modal-action">
        <label class="btn btn-primary btn-sm" @click="show = false,$emit('refreshCart','reserve')">{{ __('I make a reservation') }}</label>
        <label class="btn btn-error btn-sm" @click="show = false,$emit('refreshCart','delete')">{{ __('I have no desire') }}</label>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
defineProps(['show']);
defineEmits(['refreshCart']);
</script>